<template>
<v-content class="grey lighten-5">
  <v-container class="mainArea">
    <v-layout class="upper-row " row wrap>
      
      <v-flex class="contentWrapper justify-center text-center" xs12 sm12>

          <div class="contentContainer">
        <v-icon class="successIcon grey--text">mdi-checkbox-marked-circle-outline</v-icon>
          <h1 class="display-3 font-weight-bold black--text pb-8 pt-10">Danke für Ihre Anmeldung!</h1>
          <p>Du erhälst in Kürze eine Email mit dem Link zu Deinem Profil</p>
         <!--a href="https://werner.dfki.de/">
          <v-btn large color="accent mr-3">Jetzt Zu Werner &#8594;</v-btn>
          </a-->
          </div>
        
      </v-flex>

      
    </v-layout>

    <v-layout row wrap>
      <v-flex class="IconWrapper" xs12 md12>
        <div class="d-flex justify-center">
          
          <div class="px-12" xs-2 sm-2>
            <a href="https://kompetenzzentrum-kaiserslautern.digital/" target="_blank">
              <img
                class="partnerImg"
                :src="require('../assets/MKKLogo.png')"
                alt="Mittelstand 4.0 Logo"
              />
            </a>
          </div>

          <div class="px-12" xs-2 sm-2>
            <a href="https://www.bmwi.de/Navigation/DE/Home/home.html" target="_blank">
              <img
                class="bmwkImg"
                :src="require('../assets/bmwk_transparent.png')"
                alt="Bundesministerium für Wirtschaft und Energie Logo"
              />
            </a>
          </div>

<div class="px-12" xs-2 sm-2>
            <a href="https://www.mittelstand-digital.de/MD/Navigation/DE/Home/home.html" target="_blank">
              <img
                class="partnerImg"
                :src="require('../assets/mittelstandDigitalLogo.png')"
                alt="Bundesministerium für Wirtschaft und Energie"
              />
            </a>
          </div>



        </div>
      </v-flex>
    </v-layout>
  </v-container>

  </v-content>
</template>

<script>
export default {
  name: "Success"
};
</script>

<style scoped>
.mainArea {
  height: calc(100vh - 110px);
}

.contentContainer {
  margin: auto;
  padding: 0px 20px 100px 20px;
  position: absolute;
  width: 100%;
  height: auto;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}





.contentWrapper {
  animation: ContentAnimation 1.5s forwards 0s ease;
  height: calc(80vh - 110px);
  position: relative;
}

.IconWrapper {
  height: 30vh;
  animation: ContentAnimation 1.5s forwards 0s ease;
}

.partnerImg {
}

.partnerImg {
  opacity: 0.6;
  height: 50px;
  /* filter: url(filters.svg#grayscale); Firefox 3.5+ */
  filter: gray; /* IE5+ */
  -webkit-filter: grayscale(0.8); /* Webkit Nightlies & Chrome Canary */
  -webkit-transition: all 0.3s ease;
}

.bmwkImg {
  opacity: 0.6;
  margin-top: -50px;
  height: 150px;
  /* filter: url(filters.svg#grayscale); Firefox 3.5+ */
  filter: gray; /* IE5+ */
  -webkit-filter: grayscale(0.8); /* Webkit Nightlies & Chrome Canary */
  -webkit-transition: all 0.3s ease;
}

.bmwkImg:hover {
  opacity: 1;
  filter: none;
  -webkit-filter: grayscale(0);
}

.partnerImg:hover {
  opacity: 1;
  filter: none;
  -webkit-filter: grayscale(0);
}


/*** ANIMATIONS ***/

@keyframes ImageAnimation{
    0%{
        transform: translateX(20%);
        opacity: 0;
        }
    100%{
        transform: rotate(xx) translateX(0%);
        opacity: 1;
        }
}

@keyframes ContentAnimation{
    0%{
        transform: translateY(-20%);
        opacity: 0;
        }
    100%{
        transform: translateY(0%);
        opacity: 1;
        }
}



a:hover {
  text-decoration: none !important;
}

.successIcon {
    font-size: 100px;
}
</style>